import _ from 'lodash';
import WixEvent from '../events/WixEvent';

function getCellData(event) {
    let cellData;

    if (_.get(event, 'cellData')){
        cellData = JSON.parse(event.cellData);
    }

    return cellData;
}

/**
 * @callback $w.TableCellEventHandler
 * @summary Handles events fired when a table cell is selected.
 * @param {$w.TableCellEvent} event The table cell event that occurred.
 * @param {$w.$w} $w Deprecated: A selector function. The $w function was used to
 *  enable event handlers to work with elements in [repeaters]($w.Repeater.html). Now, to get
 *  a scoped selector for working with repeater items, use the [$w.at()]($w.html#at) function
 *  and pass it the context property of the event parameter: `$item = $w.at(event.context)`.
 */

/**
 * @class TableCellEvent
 * @summary Event that is fired when a table cell is selected.
 * @description This event is only fired if the table is
 *  [set](https://support.wix.com/en/article/table-settings) in the Editor to
 *  select cells when clicked.
 * 
 * ![Clicking Selects Cells](images/table_settings_click_cells.png "Clicking Selects Cells")
 * @memberof $w
 * @mixes $w.Event
 */
export default class TableCellEvent extends WixEvent {
    constructor (target, event) {
        super(target, event);

        this.cellRowIndex = _.get(event, 'rowIndex');
        this.cellColumnId = _.get(event, 'columnId');
        this.cellData = getCellData(event);
    }

    /**
     * @member {Number} cellRowIndex
     * @label property
     * @summary Gets the row index of the selected cell.
     * @description
     *  The rows in a table are zero-based and do not include the table header.
     * 
     *  ![Table Row Numbering](images/table_row.png "Table Row Numbering")
     * @snippet [TableCellEvent-all.es6=Get the selected table cell information]
     * @memberof $w.TableCellEvent
     * @readonly
     */


    /**
     * @member {String} cellColumnId
     * @label property
     * @summary Gets the column ID of the selected cell.
     * @description
     *  The `cellColumnId` is the `id` property of the
     *  `Column` object that corresponds to the column
     *  of the selected cell.
     * @snippet [TableCellEvent-all.es6=Get the selected table cell information]
     * @memberof $w.TableCellEvent
     * @readonly
     */


    /**
     * @member {String} cellData
     * @label property
     * @summary Gets the data from the selected cell.
     * @snippet [TableCellEvent-all.es6=Get the selected table cell information]
     * @memberof $w.TableCellEvent
     * @readonly
     */
}
